
import React from 'react';
import { Button } from 'antd';

export const isImg = /^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?/;
export const getChildrenToRender = (item, i) => {
  // 如果className包含'logo'或'item-image'且有children，则使用img标签
  if (item.className && (item.className.includes('logo') || item.className.includes('item-image')) && item.children) {
    const altText = item.className.includes('logo') ? 'logo' : 'image';
    return React.createElement('img', { 
      key: i.toString(), 
      src: item.children, 
      alt: altText,
      className: item.className 
    });
  }
  
  let tag = item.name.indexOf('title') === 0 ? 'h1' : 'div';
  tag = item.href ? 'a' : tag;
  let children = typeof item.children === 'string' && item.children.match(isImg)
    ? React.createElement('img', { src: item.children, alt: 'img' })
    : item.children;
  if (item.name.indexOf('button') === 0 && typeof item.children === 'object') {
    children = React.createElement(Button, {
      ...item.children
    });
  }
  return React.createElement(tag, { key: i.toString(), ...item }, children);
};
